/** Generic column sort helpers for restaurant data tables. */

export function str(v) {
    return v != null ? String(v).trim() : '';
}

export function parseDateSortValue(raw) {
    if (!raw) return 0;
    const s = String(raw).trim();
    if (!s) return 0;
    const normalized = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(s) ? s.replace(' ', 'T') : s;
    const d = new Date(normalized);
    return Number.isNaN(d.getTime()) ? 0 : d.getTime();
}

export function compareSortValues(va, vb, direction) {
    let cmp = 0;
    if (typeof va === 'number' && typeof vb === 'number') {
        cmp = va - vb;
    } else {
        cmp = String(va).localeCompare(String(vb), undefined, {
            numeric: true,
            sensitivity: 'base',
        });
    }
    return direction === 'asc' ? cmp : -cmp;
}

export function sortList(list, sortState, getSortValue) {
    if (!sortState?.key || !Array.isArray(list)) return list;
    return [...list].sort((a, b) =>
        compareSortValues(getSortValue(a, sortState.key), getSortValue(b, sortState.key), sortState.direction)
    );
}

export function buildSortHandlers(setSort, onPageReset) {
    const handleSortAsc = (key) => {
        onPageReset?.();
        setSort((prev) => {
            if (prev?.key === key && prev.direction === 'asc') return null;
            return { key, direction: 'asc' };
        });
    };
    const handleSortDesc = (key) => {
        onPageReset?.();
        setSort((prev) => {
            if (prev?.key === key && prev.direction === 'desc') return null;
            return { key, direction: 'desc' };
        });
    };
    return { handleSortAsc, handleSortDesc };
}
